<template>
  <div class="flex flex-col gap-y-8">
    <div class="border-b border-gray-lighten1 pb-7 md:pb-12">
      <UiLink
        to="/certificates-of-compliance"
        class="title flex items-center text-xl uppercase text-blue"
      >
        {{ $t('certificates_of_compliance') }}

        <span class="relative ml-4 h-6 w-6">
          <UiIcon icon="chevronRightThin" container-size />
        </span>
      </UiLink>
    </div>

    <div
      v-if="manuals && manuals.length > 0"
      class="flex flex-col border-b border-gray-lighten1 pb-7 md:flex-row md:gap-x-10"
    >
      <h4 class="title mb-6 w-full text-xl uppercase text-slate md:w-1/2">
        {{ $t('download') }}
      </h4>

      <ProductUserHelpDownloads class="w-full md:w-1/2" :items="manuals" />
    </div>

    <div
      v-if="faqItems && faqItems.length > 0"
      class="flex flex-col md:flex-row md:gap-x-10"
    >
      <h4 class="title mb-6 w-full text-xl uppercase text-slate md:w-1/2">
        {{ $t('faq') }}
      </h4>

      <AppFaq class="w-full md:w-1/2" :items="faqItems" />
    </div>

    <div v-if="videos && videos.length > 0">
      <h4 class="title mb-6 text-xl uppercase text-slate">
        {{ $t('video_tutorial') }}
      </h4>

      <ProductUserHelpVideos :items="videos" />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { DocumentItem } from '@webplatform/frontkit/runtime/types';
import ProductUserHelpDownloads from '~/components/sections/productSection/ProductUserHelpDownloads.vue';
import ProductUserHelpVideos from '~/components/sections/productSection/ProductUserHelpVideos.vue';

interface Props {
  manuals?: DocumentItem[];
  videos?: DocumentItem[];
  faqItems?: any[];
}

withDefaults(defineProps<Props>(), {
  manuals: () => [],
  videos: () => [],
  faqItems: () => [],
});
</script>
